import {
    ADD_CORPORATE_BILLING_MASTER_UPLOAD_SUCCESS, 
    ADD_CORPORATE_BILLING_MASTER_UPLOAD_FAILURE, 
    ADD_CORPORATE_BILLING_MASTER_UPLOAD_FAILURE_FILE, 
    CORPORATE_BILLING_MASTER_TEMPLATE_SUCCESS, 
    CORPORATE_BILLING_MASTER_TEMPLATE_FAILURE,
    CORPORATE_BILLING_MASTER_DATA_EXCEL_SUCCESS,
    CORPORATE_BILLING_MASTER_DATA_EXCEL_FAILURE,
} from './action';

const initialState = {
    addCorporateBillingMasterUploadSuccess: [],
    addCorporateBillingMasterUploadFailure: [],
    addCorporateBillingMasterUploadFailureFile: null,
}

const corporateBillingMasterReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_CORPORATE_BILLING_MASTER_UPLOAD_SUCCESS:
            return state = {
                ...state,
                addCorporateBillingMasterUploadSuccess: action
            }
        case ADD_CORPORATE_BILLING_MASTER_UPLOAD_FAILURE:
            return state = {
                ...state,
                addCorporateBillingMasterUploadFailure: action
            }
        case ADD_CORPORATE_BILLING_MASTER_UPLOAD_FAILURE_FILE:
            return state = {
                ...state,
                addCorporateBillingMasterUploadFailureFile: action.data
            }

        case CORPORATE_BILLING_MASTER_TEMPLATE_SUCCESS:
            return {
                ...state,
                corporateBillingMasterTemplateSuccess: action.data
            }

        case CORPORATE_BILLING_MASTER_TEMPLATE_FAILURE:
            return {
                ...state,
                corporateBillingMasterTemplateFailure: action.data
            }

        case CORPORATE_BILLING_MASTER_DATA_EXCEL_SUCCESS:
            return {
                ...state,
                corporateBillingMasterDataExcelSuccess: action.data
            }

        case CORPORATE_BILLING_MASTER_DATA_EXCEL_FAILURE:
            return {
                ...state,
                corporateBillingMasterDataExcelFailure: action.data
            }

        default: return state
    }
}

export default corporateBillingMasterReducer;
